// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"09933e84","286":"2d477980","309":"6ac0fbbf","391":"d75018c8","473":"254d8c39","666":"f320f5c2","764":"1477367a","867":"cb105a9c"}[chunkId] + ".chunk.js";
};